<template>
  <color-picker
    :label="$t('edit.sidebar.background_color')"
    id="triggerButtonBgColor"
    :value="boxConfig.trigger_button.style.backgroundColor"
    :change="onColorChange"
    :move="onMove"
  ></color-picker>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ColorPicker from '../../../general/ColorPicker.vue';

export default {
  components: {
    ColorPicker,
  },
  methods: {
    onColorChange(color) {
      this.boxUpdateConfigStyle({
        item: 'trigger_button',
        rule: 'backgroundColor',
        value: color,
      });
    },
    onMove(color) {
      this.boxPreviewConfigStyleChange({
        item: 'trigger_button',
        rule: 'backgroundColor',
        value: color,
      });
    },
    ...mapActions([
      'boxUpdateConfigStyle',
      'boxPreviewConfigStyleChange',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** BackgroundColor.vue?a95b2052
 **/